import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkbox_round",
  "use": "icon-checkbox_round-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-checkbox_round\">\n<g clip-path=\"url(#icon-checkbox_round_clip0_14444_16707)\">\n<circle cx=\"8\" cy=\"8\" r=\"7\" stroke=\"#999999\" stroke-width=\"2\" />\n</g>\n<defs>\n<clipPath id=\"icon-checkbox_round_clip0_14444_16707\">\n<rect width=\"16\" height=\"16\" fill=\"white\" />\n</clipPath>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol